import { ICrudLocale } from '@app/i18n/interface';

export const MARKUP_MANAGEMENT_LOCALE_EN: ICrudLocale = {
  MARKUP: {
    LABEL: {
      SINGULAR: 'Markup',
      PLURAL: 'Markups',
    },
    FORM: {
      ADD_TITLE: 'Add markup',
      EDIT_TITLE: 'Change markup',
      CARD_TITLE: 'Markup details',
      BACK: 'Back to Markups',
      ADD_DESCRIPTION: "Define a markup added on top of Hotelbeds' net price.",
      EDIT_DESCRIPTION: 'Change the value, scope or validity of this markup.',
      FETCH_ERROR: 'We could not load the markup. Please try again.',
    },
    NOTE: {
      TITLE: 'How it applies',
      BODY: 'The most specific rule applies (destination, provider, vertical and, last, global); with equal scope, the highest priority wins. If none applies, no markup is added: always keep a global rule active.',
    },
    PAGE: {
      DESCRIPTION: "Define how much is added to Hotelbeds' net price and check the final price of a rate.",
      ADD: 'Add markup',
    },
    RULE: {
      TITLE: 'How the selling price is calculated',
      STEP_1: 'We start from the net price Hotelbeds returns.',
      STEP_2: 'We add the markup. By default it is 15 to 20 % over the net.',
      STEP_3: 'If net plus markup falls below the RSP, the price goes up to the RSP.',
      STEP_4: 'If Hotelbeds flags the rate with a mandatory price, we use the RSP as is.',
      RESULT: 'The selling price is never lower than the RSP, the selling price recommended by Hotelbeds.',
    },
    EXAMPLE: {
      TITLE: 'Example with a rate',
      SUBTITLE: '2 nights, 2 adults',
      NET: 'Hotelbeds net',
      MARKUP: '{{pct}} % markup over the net',
      NET_PLUS: 'Net plus markup',
      RSP: 'Hotelbeds RSP',
      FINAL: 'Final selling price',
      NOTE: '{{netPlus}} is below the RSP, so the price goes up to {{rsp}}. With an RSP of {{lowRsp}}, the final price would be {{netPlus}}.',
      RAW_HINT: 'Provider texts, as received',
    },
    FX: {
      TITLE: 'Reference exchange rate',
      SOURCE: 'Source',
      SOURCE_ECB: 'European Central Bank (ECB), reference rates',
      LAST_RATE: 'Latest published rate',
      UPDATED: 'Last update',
      NONE: 'There is no active exchange rate yet.',
      NOTE: 'It updates by itself every working day. Use to be defined. Charges payable at the property keep their currency.',
      MANAGE: 'See exchange rates',
    },
    HELP: {
      TITLE: 'What each term means',
      MARKUP_TITLE: 'Markup',
      MARKUP_BODY: "The percentage IBSOA adds to Hotelbeds' net price. By default 15 to 20 %.",
      RSP_TITLE: 'RSP',
      RSP_BODY: 'The selling price Hotelbeds recommends. IBSOA does not sell below it.',
      FX_TITLE: 'Exchange rate',
      FX_BODY: 'Source: ECB, every working day. Use to be defined.',
    },
    VALIDITY: {
      ALWAYS: 'Always',
      FROM: 'From {{date}}',
      UNTIL: 'Until {{date}}',
    },
    FLOOR: {
      TITLE: 'Provider floor · last {{days}} days',
      BODY: 'of the {{priced}} rates shown sold at the recommended price ({{floor}}).',
      HINT: 'In that part of the catalogue the provider sets the margin, not your rule.',
      SEARCHES_ONE: 'Measured over 1 search.',
      SEARCHES: 'Measured over {{searches}} searches.',
      NO_DATA: 'No searches measured in this window yet.',
    },
    FIELD: {
      NAME: 'Name',
      SCOPE: 'Scope',
      VERTICAL: 'Vertical',
      PROVIDER_CODE: 'Provider code',
      DESTINATION: 'Destination',
      TYPE: 'Type',
      VALUE: 'Markup over net',
      VALUE_PERCENTAGE: 'Percentage (%)',
      VALUE_FIXED: 'Fixed amount',
      PRIORITY: 'Priority',
      ACTIVE: 'Active',
      STATE: 'Status',
      UPDATED: 'Last change',
      VALID_FROM: 'Valid from',
      VALID_TO: 'Valid to',
      VALIDITY: 'Validity',
    },
    SCOPE: {
      GLOBAL: 'Global',
      PROVIDER: 'Provider',
      DESTINATION: 'Destination',
      VERTICAL: 'Vertical',
    },
    TYPE: {
      PERCENTAGE: 'Percentage',
      FIXED: 'Fixed amount',
    },
    VERTICAL_OPTION: {
      HOTEL: 'Hotel',
      FLIGHT: 'Flight',
      TRANSFER: 'Transfer',
      CRUISE: 'Cruise',
    },
    VALIDATION: {
      VALUE_PATTERN: 'Enter a non-negative decimal (max. 4 decimals).',
      VALUE_PERCENTAGE_MAX:
        'The percentage cannot exceed {{ max }} (server-side validation).',
      DATE_RANGE: 'The "valid from" date must be earlier than "valid to".',
    },
    LIST: {
      TITLE: 'Markup rules',
      CAPTION: 'Markups, their scope, validity and last change',
      EMPTY: 'There are no markup rules yet: no markup is added to any rate today.',
      ACTIVE: 'Active',
      INACTIVE: 'Disabled',
      UPDATED: 'Last change',
      CHANGE: 'Change markup',
      CHANGE_ARIA: 'Change markup {{name}}',
      DISABLE: 'Disable',
      DISABLE_ARIA: 'Disable markup {{name}}',
      ENABLE: 'Enable',
      ENABLE_ARIA: 'Enable markup {{name}}',
      REMOVE: 'Remove',
      REMOVE_ARIA: 'Remove markup {{name}}',
      TOGGLE_ERROR: 'We could not change the markup. Please try again.',
    },
    REMOVE: {
      TITLE: 'Remove markup {{name}}?',
      BODY: 'It stops applying to rates and this cannot be undone from here.',
      HINT: 'If you only want to pause it, disable it.',
      KEEP: 'Keep the markup',
      CONFIRM: 'Remove markup',
      DONE: 'Markup {{name}} has been removed.',
      ERROR: 'We could not remove markup {{name}}. Please try again.',
    },
  },
};
